import Header from "../Component/UserEnd/Header";
import Contact from "../Component/UserEnd/Contact";
import Footer from "../Component/UserEnd/Footer";

function ContactPage() {
    return (
        <>
            <Header />
            <Contact/>
            <Footer />
        </>
    );
}

export default ContactPage;
